import * as React from 'react';

import Typography from '@components/basics/typography';
import MerchProduct from '../merch-product';

interface MerchProductColorProps {
  className?: string;
  productImgSrc: string;
  productColor: string;
  colorCode?: string;
  productId?: number;
  small?: boolean;
  filtered?: boolean;
  selected?: boolean;
  onClick: () => void;
}

export const MerchProductColor: React.FC<MerchProductColorProps> = ({
  className,
  productImgSrc,
  productColor,
  colorCode,
  filtered,
  productId,
  small,
  selected,
  onClick,
}) => {
  return (
    <MerchProduct
      className={className}
      small={small}
      filtered={filtered}
      productImgSrc={productImgSrc}
      productId={productId}
      colorCode={colorCode}
      selected={selected}
      onClick={onClick}
      isOnColor
    >
      <Typography type="small" align="center" weight="700">
        {productColor}
      </Typography>
    </MerchProduct>
  );
};

export default MerchProductColor;
